import fetch from '../../../utils/fetch';
import {
    OFFER_RESET,
    OFFER_SUCCESS,
} from './mutation-types';
import {EXECUTE_TRANSACTION} from '../../../constants/api-routes';

const getDefaultState = () => {
    return {
        item: [],
    };
};
const state = getDefaultState();

function success(item) {
    return {type: OFFER_SUCCESS, item};
}

function reset() {
    return {type: OFFER_RESET};
}

const getters = {
    item: state => state.item,
};

const actions = {
    executeTransaction({commit}, {offer, payerId, paymentId}) {
        return fetch(EXECUTE_TRANSACTION, {
            method: 'POST',
            data: {
                offerId: offer.id,
                offerPrice: offer.price,
                offerQuestionNumber: offer.questionNumber,
                payerId: payerId,
                paymentId: paymentId,
            },
        }).then(response => {
            commit(success(response));
        });
    },
    reset({commit}) {
        commit(reset())
    },
};

const mutations = {
    [OFFER_SUCCESS](state, payload) {
        state.item = payload.item;
    },
    [OFFER_RESET](state) {
        Object.assign(state, getDefaultState());
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/offer/execute.js